"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __DEV__ = true;
const logger_1 = require("./logger");
class LoggerApplication {
    async main() {
        const console = new logger_1.LoggerService(new logger_1.ConsoleLogger('App'));
        console.info('info');
        console.warn('warn');
    }
}
exports.LoggerApplication = LoggerApplication;
//# sourceMappingURL=application.js.map